import { useEffect, useRef, useState } from 'react';
import { fetchAuthenticatedFileBlob } from 'utils/fetchAuthenticatedFileBlob';

export function useAuthenticatedBlobUrl(fileId: string | null | undefined): {
  loading: boolean;
  url: string | null;
} {
  const [url, setUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const activeBlobUrlRef = useRef<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    if (!fileId) {
      if (activeBlobUrlRef.current) {
        URL.revokeObjectURL(activeBlobUrlRef.current);
        activeBlobUrlRef.current = null;
      }
      setUrl(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    fetchAuthenticatedFileBlob(String(fileId))
      .then((blob) => {
        if (cancelled) {
          return;
        }
        if (activeBlobUrlRef.current) {
          URL.revokeObjectURL(activeBlobUrlRef.current);
        }
        const objectUrl = URL.createObjectURL(blob);
        activeBlobUrlRef.current = objectUrl;
        setUrl(objectUrl);
      })
      .catch(() => {
        if (!cancelled) {
          setUrl(null);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
      if (activeBlobUrlRef.current) {
        URL.revokeObjectURL(activeBlobUrlRef.current);
        activeBlobUrlRef.current = null;
      }
    };
  }, [fileId]);

  return { loading, url };
}
